export default {
    succText: 'Sehr gut!',
    finishButton: 'Abschließen',
    succSubText:
        'Du hast diesen Kurs erfolgreich abgeschlossen. Sobald du alle Kurse einer Kontaktstelle geschafft hast, kannst du den Abschlusstest versuchen.',
    noPoints: 'Du hast den Kurs bereits einmal absolviert, deswegen gibt es keine neuen Punkte'
}
